import { Flex, FlexProps } from "@chakra-ui/react";

import { SpinnerIcon } from "design_system/icons";
import { colors } from "src/colors";

type Props = FlexProps & {
  size?: number;
};

export const Loading = ({ size, ...rest }: Props) => {
  return (
    <Flex
      w="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      zIndex="100"
      bg="transparent"
      id="loading"
      {...rest}
    >
      <SpinnerIcon size={size} color={colors.orange[400]} />
    </Flex>
  );
};
